<app-loader></app-loader>
<app-header></app-header>
<app-breadcrumb></app-breadcrumb>
<main id="main-content">
  <router-outlet></router-outlet>
</main>
<app-floating-bar></app-floating-bar>
<app-scroll-top></app-scroll-top>
<app-footer></app-footer>
